export default "__VITE_ASSET__e20c6bfe__"